import styled from "styled-components";

export const PaginationWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .ant-pagination-item {
    margin: 0;
    border: 1px solid #dee2e6;
    border-radius: 0;
    width: 35px;
    height: 38px;

    a {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #64748b;
    }
  }

  .ant-pagination-item:hover {
    border-color: #8b44ff;
  }

  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #6610f2;
    border-color: #8b44ff;
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 7px !important;
  }
  .ant-pagination-prev:hover .ant-pagination-item-link {
    color: #6610f2;
    border-color: #8b44ff;
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 7px !important;
  }

  .ant-pagination-item-active {
    background: #8b44ff;
    border: 1px solid #6610f2;

    a {
      color: #fff;
    }
    &:hover {
      border: none;
      a {
        color: #fff;
      }
    }
  }

  .ant-pagination .ant-pagination-prev .ant-pagination-item-link {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    /* border-radius: 0px; */
  }
  .ant-pagination .ant-pagination-next .ant-pagination-item-link {
    /* border-radius: 0px; */
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    border: 1px solid #dee2e6;
    margin: 0;
    border-radius: 0px;
    width: 35px;
    height: 38px;
    a {
      width: 100%;
      height: 100%;
    }
  }
  .ant-pagination-item-link {
    height: 100%;
    &:first-child {
      border-radius: 12px;
    }
    .ant-pagination-item-container {
      height: 100%;
    }
  }

  .ant-pagination
    .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: #8b44ff;
  }

  .ant-pagination
    .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: #8b44ff;
  }

  .ant-pagination-next,
  .ant-pagination-prev {
    /* border: 1px solid #dee2e6; */
    margin: 0;
  }
  .ant-pagination-next {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    width: 59.56px !important;
    height: 38px !important;
  }

  .ant-pagination-prev {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    width: 59.56px !important;
    height: 38px !important;
  }
`;
